import TechCards from "./components/TechCards"
import TechHero from "./components/TechHero"
import TechWeb from "./components/TechWeb"
import { Form } from "../components"

export default function Technologies() {
  return (
    <>
      <section>
        <TechHero />
        <TechCards />
        <TechWeb />

        <div className="bg-blue py-10 px-5 lg:py-20 2xl:px-0">
          <article className="xl:max-w-6xl xl:mx-auto">
            <h2 className="text-white text-3xl lg:text-5xl mb-5 lg:mb-10 lg:leading-snug">
              Contact us for more information{" "}
              <span className="block">on our tech services!</span>
            </h2>
            <Form />
          </article>
        </div>
      </section>
    </>
  )
}
